<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import AppFeedbackHost from '@/shared/ui/AppFeedbackHost.vue'

import GlobalWidgets from './layouts/components/GlobalWidgets.vue'
import { layoutOf } from './layouts/layout-of'
import { useAuthStore } from './stores/auth'
import { isWorkspaceSetUp } from './stores/session'

const route = useRoute()
const auth = useAuthStore()
/**
 * `meta.onboarding` routes (the company profile) frame the setup wizard while the current workspace is not set up.
 * Decided when the page opens, like the profile's own mode (CompanyProfileView): the wizard's last save marks the
 * workspace set up just before it leaves for the picked software, and the frame must not swap under it.
 */
const onboarding = ref(false)
watch(
  () => route.path,
  () => {
    onboarding.value = Boolean(
      route.meta.onboarding && auth.currentWorkspace && !isWorkspaceSetUp(auth.currentWorkspace),
    )
  },
  { immediate: true },
)
// `meta.layout`: full, ai (docs/ai-mode/wp/AI-1.md), else onboarding or vertical.
const layout = computed(() => layoutOf(route.meta, { onboarding: onboarding.value }))
// wp/shell OPEN-10 default (a): remount on a path change only; lists update the query without a remount.
const viewKey = computed(() => route.path)
</script>

<template>
  <component :is="layout">
    <RouterView :key="viewKey" />
  </component>
  <AppFeedbackHost />
  <!-- The global widget slot (wp/shell OPEN-16): modules' widgets.ts, outside the routes. -->
  <GlobalWidgets />
</template>
